import { render, staticRenderFns } from "./RedEnvelopeRecord.vue?vue&type=template&id=384ff495&scoped=true&"
import script from "./RedEnvelopeRecord.vue?vue&type=script&lang=js&"
export * from "./RedEnvelopeRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384ff495",
  null
  
)

export default component.exports